import { APONTAMENTO } from '../index';

/**
 * Aplica regras de seleção aos colaboradores
 */
export const applySelectionRulesToCollaborators = (payroll, selectedCollaborators) => {
  if (!payroll?.items) return [];
  return payroll.items.map((item) => {
    if (selectedCollaborators.includes(item.cooperator.id)) {
      return { ...item, requisicao: payroll.id, companyId: payroll.folha.id };
    }
    return {
      ...item,
      companyId: payroll.folha.id,
      requisicao: payroll.id,
      adiantamento: 0,
      ajudaCusto: 0,
      reembolso: 0,
      variavel: 0,
      liquido: 0,
      producao: 0,
      totalRendimentos: 0,
      descontosDiversos: 0,
      totalDebitos: 0,
    };
  });
};

/**
 * Valida se pode processar requisição
 */
export const canProcess = async (
  type,
  getFilteredItems,
  parameterization,
  validations,
  setOrderBy,
  setExceededReimbursementCollaborators,
  setShowExcessReimbursementModal
) => {
  const collaboratorsToProcess = getFilteredItems();

  if (type === APONTAMENTO.tiposRequisicoes.mensal) {
    if (!validations.canProccessMensal(collaboratorsToProcess, setOrderBy)) {
      return false;
    }
  }

  if (type === APONTAMENTO.tiposRequisicoes.adiantamento) {
    if (!validations.canProccessAdiantamento(collaboratorsToProcess)) {
      return false;
    }
  }

  if (!parameterization) {
    return false;
  }

  const emailValidation = await validations.validaEmailParametrizado(parameterization);
  if (!emailValidation.ok) {
    return false;
  }

  const exceededReimbursement = validations.getColaboradoresExcedeLimiteReembolso(collaboratorsToProcess);
  setExceededReimbursementCollaborators(exceededReimbursement);
  if (exceededReimbursement.length) {
    setShowExcessReimbursementModal(true);
    return false;
  }

  return true;
};
